import React, { useState } from 'react';
import Table from './Structures/Table';
import { Link, useParams } from 'react-router-dom';

const LobbyistClients = ({ clients }) => {
  const { state } = useParams();

  // Define the fields you might show.
  const fieldsOfInterest = [
    { key: 'BeginDate', label: 'Begin Date' },
    { key: 'StopDate', label: 'Stop Date' },
    { key: 'CompanyName', label: 'Client Name' },
    { key: 'LobbyEngagementStatus', label: 'Status' },
    { key: 'FinancialRange', label: 'Financial Range' },
  ];

  // Filter out fields that are null for every client.
  // For FinancialRange, we check if both SalaryLow and SalaryHigh are null in every record.
  const dynamicFields = fieldsOfInterest.filter((field) => {
    if (field.key === 'FinancialRange') {
      return clients.some((client) => client.SalaryLow !== null || client.SalaryHigh !== null);
    } else {
      return clients.some(
        (client) => client[field.key] !== null && client[field.key] !== undefined && client[field.key] !== ''
      );
    }
  });

  // Default sorting by CompanyName if available, else first available field.
  const defaultSortField = dynamicFields.find((f) => f.key === 'CompanyName')
    ? 'CompanyName'
    : dynamicFields[0]?.key || '';
  const [sortingField, setSortingField] = useState(defaultSortField);
  const [sortingDirection, setSortingDirection] = useState('asc');

  // Sorting function.
  const sortClients = (clients) => {
    return [...clients].sort((a, b) => {
      let valueA, valueB;
      if (sortingField === 'FinancialRange') {
        // Sort by SalaryLow as a proxy.
        valueA = a.SalaryLow || 0;
        valueB = b.SalaryLow || 0;
      } else {
        valueA = a[sortingField] || '';
        valueB = b[sortingField] || '';
      }
      if (valueA < valueB) return sortingDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return sortingDirection === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const handleSort = (field) => {
    if (sortingField === field) {
      setSortingDirection(sortingDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortingField(field);
      setSortingDirection('asc');
    }
  };

  // Build headers dynamically.
  const headers = dynamicFields.map((field) => (
    <span key={field.key} onClick={() => handleSort(field.key)} className="cursor-pointer">
      {field.label}
    </span>
  ));

  // Build table rows dynamically.
  const rows = sortClients(clients).map((client) => {
    return dynamicFields.map((field) => {
      let cellContent;
      if (field.key === 'FinancialRange') {
        // Display as "$SalaryLow - $SalaryHigh" if present.
        const low = client.SalaryLow;
        const high = client.SalaryHigh;
        if (low == null && high == null) {
          cellContent = '';
        } else {
          cellContent = `$${low?.toLocaleString() || '0'} - $${high?.toLocaleString() || '0'}`;
        }
      } else if (field.key === 'BeginDate' || field.key === 'StopDate') {
        // Optionally, format dates.
        cellContent = client[field.key] ? new Date(client[field.key]).toLocaleDateString() : '';
      } else {
        cellContent = client[field.key] || '';
      }

      // For CompanyName, wrap it in a Link.
      if (field.key === 'CompanyName') {
        return (
          <Link key={field.key} to={`/${state}/company/${client.CompanyID}`} className="lobbyCompanyName">
            {cellContent}
          </Link>
        );
      }
      return <span key={field.key}>{cellContent}</span>;
    });
  });

  return (
    <div className="bg-[#F9FAFB] border border-[#E5E7EB] 2xl:p-8 xl:p-6 p-5">
      <div className="border-b border-[#E5E7EB] mb-5 pb-2.5">
        <h2 className="font-playfair text-[28px] text-darkblue font-medium leading-8">Clients</h2>
      </div>
      {clients && clients.length > 0 ? (
        <Table headers={headers} rows={rows} />
      ) : (
        <p className="font-playfair text-[28px] text-darkblue font-medium leading-8">
          No clients found for this lobbyist.
        </p>
      )}
    </div>
  );
};

export default LobbyistClients;
